import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './style.css'
import { router } from './router'
import { auth0 } from './lib/auth0Client'

const app = createApp(App)
const pinia = createPinia()

// Initialize Auth0
app.use(auth0)
app.use(pinia)
app.use(router)
app.mount('#app')
